import React from 'react';

import CancelIcon from '@mui/icons-material/Cancel';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { Tooltip } from '@mui/material';

interface Props {
  value: boolean;
}

/**
 * Renders a boolean as a green tick or a red cross.
 *
 * Both states are drawn rather than showing a mark only when true, so a scanning eye can tell "off"
 * apart from "no value here". The icon carries a tooltip and an accessible label, since colour and
 * shape alone convey the value.
 */
export default function BooleanMark({ value }: Props) {
  const label = value ? 'Yes' : 'No';

  return (
    <Tooltip title={label}>
      {value ? (
        <CheckCircleIcon fontSize="small" color="success" aria-label={label} role="img" />
      ) : (
        <CancelIcon fontSize="small" color="error" aria-label={label} role="img" />
      )}
    </Tooltip>
  );
}
